<script setup lang="ts">

const emit = defineEmits(['keywordChange'])
defineProps<{
  placeholder: string | undefined,
}>()

const onKeyUp = (event: any) => {
  emit('keywordChange', event);
}
</script>

<template>
  <label class="filter-chip search-chip">
    <span class="search-chip-icon fa-light fa-magnifying-glass" aria-hidden="true"></span>
    <input
      type="text"
      class="search-chip-input"
      :placeholder="placeholder"
      @keyup="onKeyUp"
    />
  </label>
</template>
